export default __webpack_public_path__ + "1c6d76146e009065e608c435031202c5.png";